import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Expand = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 12 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.62482 5.25006C9.62481 5.5262 9.84867 5.75007 10.1248 5.75007C10.401 5.75008 10.6248 5.52623 10.6248 5.25008L10.6249 1.87501C10.6249 1.7424 10.5722 1.61522 10.4785 1.52145C10.3847 1.42768 10.2575 1.375 10.1249 1.375L6.74983 1.375C6.47368 1.375 6.24983 1.59886 6.24983 1.875C6.24983 2.15114 6.47368 2.375 6.74983 2.375L8.91779 2.375L6.39627 4.89651C6.20101 5.09178 6.20101 5.40836 6.39627 5.60362C6.59154 5.79888 6.90812 5.79888 7.10338 5.60362L9.62487 3.08213L9.62482 5.25006ZM2.37504 6.74998C2.37504 6.47383 2.15118 6.24997 1.87504 6.24997C1.5989 6.24997 1.37504 6.47382 1.37504 6.74997L1.375 10.1251C1.375 10.2577 1.42768 10.3849 1.52144 10.4787C1.61521 10.5724 1.74239 10.6251 1.875 10.6251H5.25014C5.52628 10.6251 5.75014 10.4013 5.75014 10.1251C5.75014 9.84897 5.52628 9.62511 5.25014 9.62511H3.08211L5.60369 7.10352C5.79896 6.90826 5.79896 6.59168 5.60369 6.39642C5.40843 6.20115 5.09185 6.20115 4.89659 6.39642L2.37501 8.91799L2.37504 6.74998Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default Expand
